import React from 'react'
import { Box, Typography, useTheme, CircularProgress } from "@mui/material";
import { tokens } from "../theme";
import { useState, useEffect } from "react";
import { ColorModeContext, useMode } from "../theme";
import { CssBaseline, ThemeProvider, Autocomplete, Backdrop } from "@mui/material";
import { Topbar } from '../layouts/Topbar';
import Sidebarr from '../layouts/Sidebar';
import Header from "../components/Header";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Button from '@mui/material/Button';
import { api } from '../api';
import { fetchToken } from '../auth/Token';
import { useLocation } from 'react-router-dom';
import { toast } from 'sonner';

export const CreateAssociations = ({isOnline}) => {
    const [open, setOpen] = React.useState(false);
    const [theme, colorMode] = useMode();
    const location = useLocation();
    const associationType_id = location.state && location.state.associationType_id;
    const [isSidebar, setIsSidebar] = useState(true);
    const [users, setUsers] = useState([]);
    const [communities, setCommunities] = useState([]);
    const [openn, setOpenn] = React.useState(false);

    const handleCloses = () => {
      setOpenn(false);
    };
    const handleOpen = () => {
      setOpenn(true);
    };

    const themee = useTheme();
    const colors = tokens(theme.palette.mode);
    
    const fetchAssoData = () => {
      api.get(`/association/all/community/in/clusters/${associationType_id}`,{
         headers :{
           Authorization: 'Bearer '+ fetchToken()
         }
       }).then(function (response){
        setCommunities(response.data?.all_yes);
       }).catch(function (error){
         console.error(error);
       })
    }
    const fetchcommunities = () => {
      api.get("/association/form/data",{
         headers :{
           Authorization: 'Bearer '+ fetchToken()
         }
       }).then(function (response){
         setUsers(response.data[1]?.facilitator);
       }).catch(function (error){
         console.error(error);
       })
   }

     useEffect(() => {
        fetchAssoData();
        fetchcommunities();
      }, []);
      
    
          const [loading, setLoading] = useState(false)
        //   var alert;
        const formik_edit = useFormik({
          initialValues: {
              "association_name": "",
              "facilitator_userid": 0,
              "association_email": "",
              "staff_userid": 0,
              "community_id": null,
              "merchant_line": "",
              "location": "",
          },
          validationSchema: Yup.object({
              "association_name": Yup.string().required("Savings Group name should not be empty"),
          }),
          onSubmit: (values) => {
              handleOpen(true)
              const data = new FormData()
              data.append('association_name',  values.association_name)
              data.append('association_type_id',   associationType_id)
              data.append('facilitator_userid', values.facilitator_userid)
              data.append('association_email',  values.association_email)
              data.append('staff_userid',  values.staff_userid)
              data.append('community_id', values.community_id)
              data.append('merchant_line', values.merchant_line)
              data.append('location', values.location)
  
              api.post('/association/create', data,{
                  headers: {
                      Authorization: 'Bearer '+ fetchToken()
                  }
              }).then(function (response) {
                if(response.data === "Savings Group already exist"){
                  toast.error(response.data)
                }else{
                  toast.success(response.data)
                  fetchAssoData();
                  formik_edit.handleReset()
                }
              }).catch(function (error){
                  console.log(error)
              }).finally(function (){
                handleCloses()
              })
          }
      });




  return (
      <div className="app">
        <main className="content">
            <Box sx={{m:5}}>
              {/* HEADER */}
              <Box display="flex" justifyContent="space-between" alignItems="center">
              <Header title="Savings Group" subtitle="Form a new Savings Group" />
              </Box>
                 <Box style={{ borderRadius:"20px", color: "#09101f", boxShadow:"15px", padding: "15px"}}>
                    <Typography variant="h4" gutterBottom>
                        Register New Savings Group
                    </Typography>
                        <form onSubmit={formik_edit.handleSubmit}>
                    <Grid container spacing={2} >
                                <Grid item xs={12} md={8}>
                                <TextField
                                    size='small'
                                    value={formik_edit.values.association_name}
                                    name='association_name'
                                    onChange={formik_edit.handleChange}
                                    onBlur={formik_edit.handleBlur}
                                    error={formik_edit.touched.association_name && Boolean(formik_edit.errors.association_name)}
                                    helperText={formik_edit.touched.association_name && formik_edit.errors.association_name}
                                    sx={{ m:1 }}
                                    variant='outlined'
                                    label='Savings Group Name'
                                />
                                
                                <TextField
                                    size='small'
                                    sx={{ m:1 }}
                                    label='Savings Group Merchant Line'
                                    onChange={formik_edit.handleChange}
                                    name='merchant_line'
                                    variant='outlined'
                                    defaultValue={formik_edit.values.merchant_line}
                                />
                                
                                <TextField
                                    size='small'
                                    sx={{ m:1 }}
                                    label='Savings Group Location (link)'
                                    onChange={formik_edit.handleChange}
                                    name='location'
                                    variant='outlined'
                                    defaultValue={formik_edit.values.location}
                                />
                                
                                <TextField
                                    size='small'
                                    value={formik_edit.values.association_email}
                                    name='association_email'
                                    onChange={formik_edit.handleChange}
                                    sx={{ m:1 }}
                                    variant='outlined'
                                    label='Savings Group Email(optional)'
                                />
                                  <Select
                                      required
                                      size='small'
                                      value={formik_edit.values.facilitator_userid}
                                      name='facilitator_userid'
                                      onChange={formik_edit.handleChange}
                                      sx={{ m:1 }}
                                      variant='outlined'
                                  >
                                      <MenuItem key={0} value={0}>Select Facilitator</MenuItem>
                                      {
                                          users.map((item) => (
                                              <MenuItem key={item.id} value={item.id}>{item.username}</MenuItem>
                                          ))
                                      }
                                  </Select>
                                  <Select
                                      required
                                      size='small'
                                      value={formik_edit.values.staff_userid}
                                      name='staff_userid'
                                      onChange={formik_edit.handleChange}
                                      sx={{ m:1 }}
                                      variant='outlined'
                                  >
                                      <MenuItem key={0} value={0}>Select Staff</MenuItem>
                                      {
                                          users.map((item) => (
                                              <MenuItem key={item.id} value={item.id}>{item.username}</MenuItem>
                                          ))
                                      }
                                  </Select>
                                <Autocomplete
                                  disablePortal
                                  id="combo-box-demo"
                                  options={communities}
                                  getOptionLabel={(option) => `${option.community} (${option.cluster})`}
                                  isOptionEqualToValue={(option, value) => option.community_id === value.community_id}
                                  onChange={(event, value) => formik_edit.setFieldValue('community_id', value.community_id)}
                                  renderInput={(params) => <TextField {...params} name='community_id' label="Select Community" size="small" />}
                                />
                                <Button
                                    variant='contained'
                                    type='submit'
                                    color='success'
                                    size='small'
                                    sx={{ m:1 }}
                                >
                                    {
                                        loading === true ?
                                        <Box sx={{ width: '100%' }}>
                                            <CircularProgress />
                                        </Box>
                                        : "Create"
                                    }
                                </Button>
                                <Button
                                    variant='contained'
                                    onClick={formik_edit.handleReset}
                                    color='error'
                                    size='small'
                                    sx={{ m:1 }}
                                >
                                    Clear form
                                </Button>
                                </Grid>
                            </Grid>
                            </form>
                            <Backdrop
                                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                                open={openn}
                                onClick={handleCloses}
                            >
                                <CircularProgress color="inherit" />
                            </Backdrop>
                </Box>
            </Box>
          </main>
        </div>
  )
}